import React, { useId } from 'react';

// The X is cut out of the disc rather than painted over it, so it shows whatever surface sits behind it.
export const IconCloseCircle: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    const maskId = useId();
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
            <mask id={maskId}>
                <rect width="24" height="24" fill="white" />
                <path d="M9 9L15 15M15 9L9 15" stroke="black" strokeWidth="1.75" strokeLinecap="round" />
            </mask>
            <circle cx="12" cy="12" r="10" fill="currentColor" mask={`url(#${maskId})`} />
        </svg>
    );
};
